<template>
  <!-- CPAP 案件検索 -->
  <div id="CpapRequestSearch">
    <div id="container">
      <div class="labelTitle lable">CPAP 案件検索</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
            <th>種別</th>
            <td>
              <select v-model="searchConditions.kind">
                <option value=""></option>
                <option v-for="item in kindGroupMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>種別区分</th>
            <td colspan="3">
              <div style="margin-left: 10px">
                <b-checkbox class="columnCheckBox" v-model="searchConditions.kindClassification.normal">直送・支店出荷</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="searchConditions.kindClassification.notDirections">仮持出</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="searchConditions.kindClassification.deposit">預託機</b-checkbox>
              </div>
            </td>
          </tr>
          <tr>
            <th>申込み状況</th>
            <td>
              <select v-model="searchConditions.progress">
                <option value="[]"></option>
                <option v-for="item in progressList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>状態</th>
            <td>
              <select v-model="searchConditions.status">
                <option value="[]"></option>
                <option v-for="item in statusList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>営業担当者</th>
            <td><input type="text" v-model="searchConditions.salesStaffName"/></td>
            <th>営業所<br/>（売上）</th>
            <td>
              <select v-model="searchConditions.salesOfficeCode">
                <option value=""></option>
                <option v-for="item in salesOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>医療機関<br/>コード</th>
            <td><input type="text" v-model="searchConditions.medicalInstitutionCode"/></td>
            <th>医療機関名</th>
            <td><input type="text" v-model="searchConditions.medicalInstitutionName"/></td>
            <th>組織ID</th>
            <td><input type="text" id="searchBelongsid" name="組織ID" v-model="searchConditions.belongsId"/></td>
            <th>指示書<br>承認待ち</th>
            <td>
              <select v-model="searchConditions.approval">
                <option value=""></option>
                <option :value="true">得意先承認待ちのみ</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>患者コード</th>
            <td><input type="text" v-model="searchConditions.patientCode"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName"/></td>
            <th>患者名<br/>（カナ）</th>
            <td><input type="text" v-model="searchConditions.patientNameKana"/></td>
            <th>診察券ID<br/>（患者ID）</th>
            <td>
              <input 
                type="text" 
                v-model="searchConditions.patientRegistrationCard" 
                maxlength="50" 
                class="3" 
                name="診察券ID（患者ID）" 
                validate="required"/>
            </td>
          </tr>
          <tr>
            <th>機種</th>
            <td><select id="model" name="機種" v-model="searchConditions.model">
              <option value="[]"></option>
              <option v-for="model in modelList" :value="model.itemCodes" :key="model.itemCodes">{{ model.itemName }}</option>
            </select></td>
            <th>本体<br/>シリアル</th>
            <td><input type="text" v-model="searchConditions.serial"/></td>
          </tr>
          <tr>
            <th>申込日</th>
            <td colspan="3">
                  <input type="date" v-model="searchConditions.applicationDateStart"/>
               ～ <input type="date" v-model="searchConditions.applicationDateEnd"/>
            </td>
            <th>完了日</th>
            <td colspan="3">
                  <input type="date" v-model="searchConditions.completionDateStart"/>
               ～ <input type="date" v-model="searchConditions.completionDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="data.length > 0">
        <div style="float:left">
          <b-button style="margin-right:10px;" class="clipboadCopyButton is-primary" @click="clipboardCopy('cpapRequesSearchTable')">クリップボードにコピー</b-button>
          <b-button v-if="!isOpen" @click="isOpen=true" class="is-primary" icon-left="table-column-width" >列選択</b-button>
          <b-button v-if="isOpen" @click="isOpen=false" class="is-primary" icon-left="close-box-outline" >閉じる</b-button>
          <div v-if="isOpen" style="clear:both; height:0px;" >
            <div class="box selectColumn">
              <div style="height:30px;">
                <b-checkbox class="columnCheckBox" v-model="isAllChecked" @input="changeAllCheckBox" >全てチェック</b-checkbox>
                <a style="float:right;" @click="isOpen=false"><b-icon icon="close"/></a>
              </div>
              <b-checkbox class="columnCheckBox" v-model="columns.receiptNumber.checked" @input="changeCheckBox(columns.receiptNumber)" >受付番号</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.kind.checked" @input="changeCheckBox(columns.kind)" >種別</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.client.checked" @input="changeCheckBox(columns.client)" >依頼元</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.medicalInstitutionName.checked" @input="changeCheckBox(columns.medicalInstitutionName)" >医療機関名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.patientCode.checked" @input="changeCheckBox(columns.patientCode)" >患者コード</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.patientName.checked" @input="changeCheckBox(columns.patientName)" >患者名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.applicationDate.checked" @input="changeCheckBox(columns.applicationDate)" >申込日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.completionDate.checked" @input="changeCheckBox(columns.completionDate)" >完了日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.progress.checked" @input="changeCheckBox(columns.progress)" >申込み状況</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.status.checked" @input="changeCheckBox(columns.status)" >状態</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.inquiry.checked" @input="changeCheckBox(columns.inquiry)" >問い合わせ</b-checkbox>
            </div>
          </div>
        </div>
        <div>
          <span class="result-count" style="position: relative; top:6px;">件数：{{data.length}}件</span>
          <b-table
            id="cpapRequesSearchTable"
            :data="data"
            :paginated="true"
            per-page="100"
            pagination-position="both"
            default-sort="receiptNumber"
            default-sort-direction="desc"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column :visible="columns.receiptNumber.checked"  field="receiptNumber" label="受付番号" :width="columns.receiptNumber.width" centered sortable>
                <router-link :to="{name:'CpapRequestDetail', params:{receiptNumber:props.row.receiptNumber, kind:props.row.kind, status:props.row.status, searchConditions:searchConditions, isTemp:props.row.tempFlag}}"><a>{{props.row.receiptNumber}}</a></router-link>
                <br><span v-if="props.row.equipmentReturnErrFlag" class="equipmentReturnErr"/>
              </b-table-column>
              <b-table-column :visible="columns.kind.checked"  field="kind" label="種別" :width="columns.kind.width" sortable>{{props.row.kind | codeFilter(kindGroupMaster, props.row.cancelResume)}}
                <span v-if="props.row.depositUseFlag && props.row.kind!=3 && props.row.kind!=4 && props.row.kind!=10 && props.row.kind!=20" class="depositUse"/>
                <span v-if="props.row.tempFlag && props.row.kind!=3 && props.row.kind!=4 && props.row.kind!=10 && props.row.kind!=20" class="notDirections"/>
              </b-table-column>
              <b-table-column :visible="columns.client.checked"  field="client" label="依頼元" :width="columns.client.width" sortable>{{props.row.client}}<span v-if="props.row.proxyFlag" class="agent"/></b-table-column>
              <b-table-column :visible="columns.medicalInstitutionName.checked"  field="medicalInstitutionName" label="医療機関名" :width="columns.medicalInstitutionName.width" sortable>{{props.row.medicalInstitutionName}}</b-table-column>
              <b-table-column :visible="columns.patientCode.checked"  field="patientCode" label="患者コード" :width="columns.patientCode.width" sortable>{{props.row.patientCode}}</b-table-column>
              <b-table-column :visible="columns.patientName.checked"  field="patientName" label="患者名" :width="columns.patientName.width" sortable>{{props.row.patientName}}</b-table-column>
              <b-table-column :visible="columns.applicationDate.checked"  field="applicationDate" label="申込日" :width="columns.applicationDate.width" centered sortable>{{props.row.applicationDate}}</b-table-column>
              <b-table-column :visible="columns.completionDate.checked"  field="completionDate" label="完了日" :width="columns.completionDate.width" centered sortable>{{props.row.completionDate}}</b-table-column>
              <b-table-column :visible="columns.progress.checked"  field="progress" label="申込み状況" :width="columns.progress.width" centered sortable>
                <span :class="getCpapStatusClass(props.row.status,props.row.kind)">
                  {{getCpapProgres(props.row.status,props.row.kind)}}
                </span>
              </b-table-column>
              <b-table-column :visible="columns.status.checked"  field="status" label="状態" :width="columns.status.width" centered sortable>
                <span :class="getCpapInnerStatusClass(props.row.status)" style="width:80%;">
                  {{props.row.statusName}}
                </span>
              </b-table-column>
              <b-table-column :visible="columns.inquiry.checked"  field="mailto" label="問い合わせ" :width="columns.inquiry.width" centered>
                <a :href="props.row.mailto">
                  <b-icon icon="email-outline"/>
                </a>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
      <div class="result-area" v-if="dataBlank && data.length == 0">
        <div class="result-count">件数：{{data.length}}件</div>
      </div>
    </div>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import { cpapSearchKindGroup } from "@/components/mock/base/const.js";
import { cpapKindMap } from "@/components/mock/base/const.js";

export default {
  name: "CpapRequestSearch",
  methods: {
    doSearch: function() {
      let isSearchParam = false
      var element = document.getElementById("searchBelongsid")
      element.style["border-color"] = "";
      let keys = Object.keys(this.searchConditions)
      for(let i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]+"" !="" && this.searchConditions[keys[i]] !="[]"){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      // 半角数字チェック
      if (this.searchConditions.belongsId && !(String(this.searchConditions.belongsId).match(/^\d+$/))) {
        element.style["border-color"] = "red";
        this.showErrorMessage(element.name + "は半角数字で入力してください。\n")
        return
      }

      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          let conditionStatus = JSON.parse(_this.searchConditions.status);
          let conditionProgress = JSON.parse(_this.searchConditions.progress);
          let conditionModel = JSON.parse(_this.searchConditions.model);
          var kind = _this.searchConditions.kind
          var depositUse = ""
          if(kind == 99 || kind == 100){
            // 99:新規処方申込み(預託機有り)
            // 100:新規処方申込み(預託機無し)
            kind = cpapKindMap.application
            depositUse = _this.searchConditions.kind == 99 ? "1" : "0"
          }
          var obj = {
            receiptNumber: _this.searchConditions.receiptNumber,
            kind:  kind,
            progress: conditionProgress,
            kindClassification: _this.searchConditions.kindClassification,
            status: conditionStatus,
            medicalInstitutionCode: _this.searchConditions.medicalInstitutionCode,
            medicalInstitutionName: _this.searchConditions.medicalInstitutionName,
            belongsId: _this.searchConditions.belongsId,
            patientCode: _this.searchConditions.patientCode,
            patientName: _this.searchConditions.patientName,
            patientNameKana: _this.searchConditions.patientNameKana,
            model: conditionModel,
            serial: _this.searchConditions.serial,
            salesOfficeCode: _this.searchConditions.salesOfficeCode,
            salesStaffName: _this.searchConditions.salesStaffName,
            applicationDateStart: _this.searchConditions.applicationDateStart,
            applicationDateEnd: _this.searchConditions.applicationDateEnd,
            completionDateStart: _this.searchConditions.completionDateStart,
            completionDateEnd: _this.searchConditions.completionDateEnd,
            approval:_this.searchConditions.approval,
            depositUse:depositUse,
            patientRegistrationCard: _this.searchConditions.patientRegistrationCard,
            sendBackFlag:_this.searchConditions.sendBackFlag,
            isTask:_this.isTask,
          }
          return client.apis.internalCpap.getCpapMatterListPOST({
            body:obj
          });
        },
        function(result){
          _this.data = result.obj;
          var count = 0;
          if(_this.data && _this.data.length > 0){
            var subject = encodeURI("【問合せ】 <ここに件名を記載してください> Philips Care Portal")
            for(var item of _this.data){
              count++;
              // メール本文に記載する種別の名称取得
              let findKind
              if(item.kind == 5 && item.cancelResume == false){ //処方再開申込みの場合「中止再開」と「転入」区別
                findKind = 6
              } else if(item.kind == 7){ //仮持出申込の場合、新規処方申込みに変更
                findKind = 1
              } else {
                findKind = item.kind
              }
              let target = _this.kindGroupMaster.find((value) => { return findKind == value.code; });
              let kindName = target ? target.name : "";
              // mailtoを設定
              var body = encodeURI("\n【受付番号】"+item.receiptNumber+"\n【種別】CPAP"+ kindName +"\n\n【お問い合わせ内容】\n\n<ここにお問い合わせ内容を記載してください。>\n")
              //item.mailto = "mailto:"+ item.clientlMailAddress + "?subject="+subject+"&body="+body;
              if (item.cpapMailingList.length == 0){
                item.mailto = "mailto:"+ item.clientlMailAddress + "?subject="+subject+"&body="+body;
              } else {
                var ccString = item.cpapMailingList.join(';')
                item.mailto = "mailto:"+ item.clientlMailAddress + "?cc=" + ccString + "&subject="+subject+"&body="+body;
              }
            }
            //指定件数を超えていた場合、メッセージ表示
            if(_this.data[0].executeQueryLimitMessage) {
              _this.showMessage(_this.data[0].executeQueryLimitMessage)
            }
            // _this.$nextTick(() => {
            //   _this.chengeTableWidth(_this.tableWidth);
            // })
          }
          _this.dataBlank = true;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    changeCheckBox: function(checkboxModel) {
      var width = checkboxModel.width;
      var tableElement = this.getTableElement();
      var newWidth = 0;
      if (checkboxModel.checked) {
        newWidth = tableElement.clientWidth + width;
      } else {
        newWidth = tableElement.clientWidth - width;
      }
      this.chengeTableWidth(newWidth);
    },
    getTableElement: function(){
      var parentElement = document.getElementById(
        "cpapRequesSearchTable"
      );
      return parentElement.getElementsByTagName("table")[0];
    },
    changeAllCheckBox: function() {
      if(this.isAllChecked){
        this.chengeTableWidth(this.tableWidth);
      } else {
        this.chengeTableWidth(0);
      }
      Object.values(this.columns).map(clumn => clumn.checked = this.isAllChecked)
    },
    chengeTableWidth: function(width){
      var tableElement = this.getTableElement();
      tableElement.style.width = width + "px";
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      var tr = tbody.getElementsByTagName("tr")
      var records = []
      for (let i = 0; i < tr.length ;i++) {
        let lineBreakRemoval = tr[i].innerText.replace(/\r?\n/g, ""); // 改行を削除
        records.push(lineBreakRemoval)
      }
      navigator.clipboard
        .writeText(records.join("\n"))
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    getDate(){
      return this.yyyy_hyp_MM_hyp_dd(new Date());
    },
    getSeveralMonthAgoDate(month) {
      let today = new Date();
      // nか月前の日付を計算
      today.setMonth(today.getMonth() - month);
      return this.yyyy_hyp_MM_hyp_dd(today);
    },
  },
  data() {
    var columns = {
        receiptNumber: { checked: true, width: 110 },
        kind: { checked: true, width: 180 },
        client: { checked: true, width: 300 },
        medicalInstitutionName: { checked: true, width: 300 },
        patientCode: { checked: true, width: 150 },
        patientName: { checked: true, width: 150 },
        applicationDate: { checked: true, width: 100 },
        completionDate: { checked: true, width: 100 },
        progress: { checked: true, width: 100 },
        status: { checked: true, width: 100 },
        inquiry: { checked: true, width: 100 },
      }
    var tableWidth = 0;
    Object.values(columns).map(clumn => {
      if(clumn.checked) tableWidth += clumn.width
    })
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var salesOfficeCode = userInfo.salesOfficeCode;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var defaultDate = this.getDate();
    var defaultApplicationDateStart = this.getSeveralMonthAgoDate(1);
    let kindGroupMaster = cpapSearchKindGroup
    let statusList = this.getCpapStatusList();
    let progressList = this.getCpapProgressList();
    let modelList = this.getCpapMaster();
    let salesOfficeMaster = this.getSalesOfficeMaster();
    var patientStatusList = this.getCpapPatientProgressList();
    var isTask = false
    var progress = "[]"
    var salesStaffName, applicationDateStart, applicationDateEnd
    // タスクから遷移した場合、申込み状況「仮受付」、営業担当者「ログインユーザー名」をデフォルトで設定
    if (this.$route.params["isTask"]) {
      isTask = true
      progress = progressList.find(val => val.name == "仮受付").code
      salesStaffName = userInfo.lastName + ' ' + userInfo.firstName
      salesOfficeCode = ''
      applicationDateStart = ''
      applicationDateEnd = ''
    } else {
      applicationDateStart = defaultApplicationDateStart
      applicationDateEnd = defaultDate
    }
    let kindClassification = {
      normal: true,
      deposit: true,
      notDirections: true,
    }
    let searchConditions = {
      receiptNumber:"",
      kind:"",
      kindClassification: kindClassification,
      progress:progress,
      status:"[]",
      medicalInstitutionCode:"",
      medicalInstitutionName:"",
      belongsId:"",
      patientCode: "",
      patientName: "",
      patientNameKana: "",
      model:"[]",
      serial:"",
      salesOfficeCode:salesOfficeCode,
      salesStaffName:salesStaffName,
      applicationDateStart:applicationDateStart,
      applicationDateEnd:applicationDateEnd,
      completionDateStart:"",
      completionDateEnd:"",
      approval:"",
      patientRegistrationCard: "",
      sendBackFlag: false,
    }
    return {
      takeOverSearchParams,
      searchConditions,
      data: [],
      roleId: roleId,
      userId: userId,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      role: role,
      choicesType:choicesType,
      kindGroupMaster,
      statusList,
      progressList,
      modelList,
      salesOfficeMaster,
      isPaginated : true,
      patientStatusList,
      cpapKindMap:cpapKindMap,
      isOpen: false,
      isAllChecked: false,
      columns: columns,
      tableWidth : tableWidth,
      dataBlank: false,
      isTask:isTask,
    };
  },
  filters: {
    codeFilter(value,list,cancelResume){
      // QA415: CPAP_KIND_GROUP_MASTER_FOR_SEARCHの変更につき、kindの値変換
      let findValue
      if(value == 5 && cancelResume == false){
        findValue = 6
      } else if(value == 7){
        findValue = 1
      } else {
        findValue = value
      }
      var target = list.find(val => val.code == findValue)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {},
  async mounted() {
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams;
      this.doSearch();
    }
    // QA490 タスクから遷移した際、申込み状況「仮受付」、営業担当者「ログインユーザー名」を設定し、検索
    if (this.isTask) {
      this.doSearch();
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
select {
  width: 200px;
}
.tag {
  width: 100px;
}
.selectColumn {
  width: 800px;
  position: absolute;
  background-color: white;
  z-index: 25;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/cpap/RequestSearch.vue